import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import {
  Box,
  TextField,
  Autocomplete,
  autocompleteClasses,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import useStyles from "./styles";
import { Colors, CommonFonts } from "@/theme";

const WeekPicker = ({ label, week, onChange }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const currentWeek = useRef(moment().isoWeek());
  const weeks = Array.apply(null, Array(moment().isoWeeksInISOWeekYear())).map(
    (val, i) => i + 1
  );

  return (
    <Box>
      <span className={classes.selectText}>{label}</span>
      <Autocomplete
        className={classes.selectContainer}
        options={weeks}
        getOptionLabel={(option) =>
          option === currentWeek.current
            ? t("dashboard_screen.this_week")
            : option === currentWeek.current - 1
            ? t("dashboard_screen.last_week")
            : `Week ${option}`
        }
        renderInput={(params) => <TextField {...params} />}
        popupIcon={<ExpandMoreIcon sx={{ color: Colors.GRAY_DARK }} />}
        value={week}
        onChange={(event, newValue) => {
          onChange(newValue);
        }}
        disableClearable
        blurOnSelect
        renderOption={(props, option, state, ownerState) => (
          <Box
            sx={{
              [`&.${autocompleteClasses.option}`]: {
                padding: "8px",
                ...CommonFonts.darkBoldFont22,
              },
            }}
            component="li"
            {...props}
          >
            {ownerState.getOptionLabel(option)}
          </Box>
        )}
      />
    </Box>
  );
};

export default WeekPicker;
